export const hostelRules = [
  "Students must maintain discipline and decorum inside the hostel premises.",
  "Hostel timings must be followed strictly unless prior permission is obtained.",
  "Visitors are allowed only as per hostel rules and with required permission.",
  "Rooms and common areas must be kept clean and hygienic.",
  "Electrical appliances should be used responsibly and only where permitted.",
  "Damage to hostel property must be reported immediately and may attract charges.",
  "Students must avoid activities that disturb other residents.",
  "The hostel administration's instructions must be followed at all times.",
];
